import { render, staticRenderFns } from "./ResourceCenterExpandable.vue?vue&type=template&id=19c3a277"
import script from "./ResourceCenterExpandable.vue?vue&type=script&lang=js"
export * from "./ResourceCenterExpandable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports